"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPreferenceDurabiliteCorporation = void 0;
exports.ESubPreferenceDurabiliteCorporation = {
    prise_en_compte_principales_incidences_negatives: "prise_en_compte_principales_incidences_negatives",
    investissements_durables: "investissements_durables",
    investissements_durables_sur_plan_environnemental: "investissements_durables_sur_plan_environnemental",
};
